import React from 'react';
import { Modal, Button, Form, Input } from 'antd';

import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';

class NoteModal extends React.Component {
	state = { modalOpen: false }
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.form.validateFields((err, values) => {
			if (err) return stickyError('Invalid input');
			this.props.onNoteUpdate(this.props.award.id, values.note).then(result => {
				this.props.isSubmitted();
			});
		});
	}
	render() {
		return (
			<div>
				<Button icon="file-text" onClick={e => this.setState({ modalOpen: !this.state.modalOpen })} />
				<Modal visible={this.state.modalOpen} closable={false} width={800}
					title={(this.props.variant === 'admin')? 'Note to student': 'Award note'}
					footer={[<Button onClick={() => this.setState({ modalOpen: false })}>Close</Button>]}>
					<div>
						{this.props.award.type && this.props.award.type.acceptLanguage && 
							<p style={{marginBottom: '16pt'}}>
								{this.props.award.type.acceptLanguage}
							</p>
						}
						{(this.props.variant === 'admin')?
							<Form onSubmit={this.handleSubmit}>
								<Form.Item>
									{this.props.form.getFieldDecorator('note', {
										initialValue: this.props.award.note
									})(
										<Input.TextArea />
									)}
								</Form.Item>
								<SaveButton
									disabled={!this.props.form.isFieldsTouched()}
									loading={this.props.getStatus().submitting} />
							</Form>
						:
							<p>
								{this.props.award.note}
							</p>
						}
					</div>
				</Modal>
			</div>
		);
	}
}

export default withSpin(Form.create()(NoteModal));



// WEBPACK FOOTER //
// ./portal-components/Portal/Financial/FinancialAid/NoteModal.jsx